<template>



  <el-form label-width="auto" size="small">

    <el-form-item label="标题">
      <el-input placeholder="请输入标题" v-model="ele.style.title"></el-input>
    </el-form-item>

    <el-form-item label="序号">
      <el-switch v-model="ele.style.enableNumber"></el-switch>
    </el-form-item>

  </el-form>

</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      default: () => {
        return {}
      }
    },
    element: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      ele:{},
      attrs: {
        enableNumber: false
      }
    }
  },
  created() {

    this.ele = this.element;

    //初始化样式属性
    Object.keys(this.attrs).forEach(key => {
      if (this.ele[key] === undefined) {
        this.ele[key] = this.deepClone(this.attrs[key]);
      }
    })

  },

}

</script>

<style scoped lang="scss">

.el-input{
  width: 200px;
}

</style>